import { t } from './i18n';

// Environnement : réglé dans server/config/env.json, fichier partagé avec le PHP.
// env.json est recopié ici au lancement de npm start / npm run build (cf. scripts/sync-env.js) :
// relancer npm start après l'avoir modifié.
import env from './env.json';

// 0 = Prod, 1 = Formation, autre = Local
export const _IS_LOCAL_ = env.IS_LOCAL;
// Environnement du web service livescore (dafunker) : 0 = production, 1 = préprod
export const IS_PREPROD = env.IS_PREPROD;
// Affichage des playoffs / playdowns Pro A Dames et Pro B Messieurs, et des playoffs Pro A Messieurs
// (sous-menu "Playoffs" de la division et encarts de l'accueil)
export const PLAYOFFS_VISIBLE = env.PLAYOFFS_VISIBLE === 1;
export const PLAYOFFS_PROA_VISIBLE = env.PLAYOFFS_PROA_VISIBLE === 1;

// Prod / Formation : on appelle le backend sur l'origine de la page. Le site répond aussi
// sur https://fftt.com (sans www) : viser www.fftt.com en dur rendait les appels cross-origin,
// refusés par restrictToSiteOrigin() (403 sans CORS -> "Network Error", contenu vide).
const getDomain = () => {
    switch (_IS_LOCAL_) {
        case 0: // Prod
            return window.location.origin + '/pro';
        case 1: // Formation
            return window.location.origin + '/pro_dev_20250211';
        default: // Local
            return 'http://localhost/pro';
    }
}

export const domain = getDomain();

// URL et port du web service livescore selon l'environnement
export const URL_WS_URL = IS_PREPROD === 1
    ? 'http://preprod.fftt.dafunker.com'
    : 'https://fftt.dafunker.com';

export const URL_WS_PORT = IS_PREPROD === 1 ? 2091 : 3000;


// Listes des clubs par championnats
export const listClubProam = [];
export const listClubProbm = [];
export const listClubProad = [];
export const listClubProbd = [];

// Nom long du championnat, dans la langue courante (cf. i18n/translations.js)
export const getLongNameChamp = (value) => {
    return ['proam', 'probm', 'proad', 'probd', 'preprod'].includes(value) ? t('champ.' + value) : undefined;
}

// Championnat féminin (libellés accordés : « joueuses »...)
export const isChampDames = (value) => value === 'proad' || value === 'probd';

export const getCorrectListClub = (value) => {
    switch (value) {
        case 'proam':
            return listClubProam;
        case 'probm':
            return listClubProbm;
        case 'proad':
            return listClubProad;
        case 'probd':
            return listClubProbd;
        default:
            break;
    }
}

// ST-DENIS US 93 TT 1

// Ces liens pointaient auparavant directement vers apiv2.fftt.com / www.fftt.com
// (requêtes exécutées côté client). Ils passent désormais par notre backend
// (server/getEquResult.php), qui exécute la requête côté serveur.
export const apiLink = [
    {id: 1, link: `${domain}/server/getEquResult.php?division=proam`, for: 'proam'},
    {id: 2, link: `${domain}/server/getEquResult.php?division=probm`, for: 'probm'},
    {id: 3, link: `${domain}/server/getEquResult.php?division=proad`, for: 'proad'},
    {id: 4, link: `${domain}/server/getEquResult.php?division=probd`, for: 'probd'},
]

export const classementAPI = [
    {id: 1, link: `${domain}/server/getEquResult.php?division=proam&classement=1`, for: 'proam'},
    {id: 2, link: `${domain}/server/getEquResult.php?division=probm&classement=1`, for: 'probm'},
    {id: 3, link: `${domain}/server/getEquResult.php?division=proad&classement=1`, for: 'proad'},
    {id: 4, link: `${domain}/server/getEquResult.php?division=probd&classement=1`, for: 'probd'},
]

